import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { tradeAttachmentsQueryKey } from "./useTradeAttachments";

type AttachmentResponse = components["schemas"]["AttachmentResponse"];

export type UploadAttachmentVariables = {
  tradeId: string;
  file: File;
};

export function useUploadAttachment() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<AttachmentResponse, Error, UploadAttachmentVariables>({
    mutationFn: async ({ tradeId, file }) => {
      const formData = new FormData();
      formData.append("file", file);
      const { data, error } = await client.POST(
        "/api/trades/{trade_id}/attachments",
        {
          params: { path: { trade_id: tradeId } },
          body: { file } as unknown as { file: string },
          bodySerializer: () => formData,
        },
      );
      if (error !== undefined) {
        throw new Error(`Failed to upload attachment for trade ${tradeId}`);
      }
      return data;
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: tradeAttachmentsQueryKey(variables.tradeId),
      });
    },
  });
}
